// Decoupled sign-out seam for persisted optimistic overlays. Each overlay
// service registers a clear-callback here on module load; `teardown` invokes
// them all on sign-out WITHOUT importing any domain module — importing e.g.
// `track/` from the auth/teardown side would form an `auth ↔ track` bi-reference
// (track already imports auth), which `check:biref` rejects. This registry has
// no src imports, so it can never close such a cycle. Only a loaded service
// registers, and only a loaded service holds in-memory overlay state to clear,
// so an unregistered overlay is already empty (its persisted half is wiped by
// teardown's `localStorage.clear()`).

const clears = new Set<() => void>()

/** Register a sign-out clear-callback (idempotent per callback identity). */
export function registerSignOutClear(clear: () => void): void {
    clears.add(clear)
}

/** Invoke every registered clear-callback; each is independently guarded so a
 * throw in one never skips the rest. */
export function runSignOutClears(): void {
    for (const clear of clears) {
        try {
            clear()
        } catch {
            // Best-effort: a failed clear must not skip the others.
        }
    }
}
